import { authRoles } from '../../auth/authRoles'
import React from 'react'

const userRoute = [
    {
        path: '/users/list',
        component: React.lazy(() => import('./UUser')),
        auth: authRoles.admin,
    },
    {
        path: '/departments',
        component: React.lazy(() => import('./UDepartment')),
        auth: authRoles.admin,
    },
    {
        path: '/profile',
        component: React.lazy(() => import('./UProfile')),
        auth: authRoles.user,
    },
    {
        path: '/admin/setting',
        component: React.lazy(() => import('./USettings')),
        auth: authRoles.user,
    },
    {
        path: '/admin/logs',
        component: React.lazy(() => import('./UAuditLogs')),
        auth: authRoles.user,
    }
]

export default userRoute
